import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsFieldLayoutsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-view',
	path: '/secure/admin/ViewFieldLayouts.jspa',
};
